// extracted by mini-css-extract-plugin
module.exports = {"action":"user_panel_action__3hw0I","avatar":"user_panel_avatar__iK4VX"};